import { SET_PRESETS } from '../constants/index';

export const initialPresets = []

const presetsReducer = (state = initialPresets, action) => {
	switch(action.type){
        
        case SET_PRESETS:
            state = action?.payload || state
        break;
		default:	
            return state;  		
    }
    return state
}
export default presetsReducer;